import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { PackageService } from '@services/packages/package.service';
import { DataTableEvent } from '../../components/data-table/data-table.component';

@Component({
    selector: 'app-failed-packages',
    templateUrl: './failed-packages.component.html',
    styleUrls: ['./failed-packages.component.scss'],
    providers: [PackageService],
    standalone: false
})
export class FailedPackagesComponent implements OnInit {

  public title = 'Failed packages';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'title', name: 'Title' },
    { prop: 'cache.success', name: 'Package' },
    { prop: 'cache.successDynamicContent', name: 'DynamicContent' },
    { prop: 'cache.successScreenGenerator', name: 'Screen' },
  ];

  public params: any;

  constructor(
    public packageService: PackageService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.params = {
      $or: [{ 'cache.success': false }, { 'cache.successDynamicContent': false }, { 'cache.successScreenGenerator': false }]
    };
  }

  public onDetail(event: DataTableEvent): void {
    console.log(event.row._id);
    this.router.navigate(['failed-packages', 'detail', event.row._id]);
  }

}
